// extracted by mini-css-extract-plugin
module.exports = {"infoRow":"InfoRow_infoRow__2_dmd","valPair":"InfoRow_valPair__wYdP1","value":"InfoRow_value__2TSpH"};